import { FontIcons } from '@brandfolder/react';
import { t } from '@lingui/macro';
import React, { SyntheticEvent } from 'react';

import { handleThumbnailError } from '@components/asset/modal/tabs/edit/helpers';
import { ImageOverlay } from '@components/people_tags/common/ImageOverlay';
import { PeoplePageParamKeys } from '@components/people_tags/customPeopleTagTypes';

interface AttachmentImageProps {
  assetKey: string;
  assetName: string;
  attachmentCount: number;
  attachmentExtension: string;
  src: string;
  isTask?: boolean;
}

const AttachmentThumbnail = (props: AttachmentImageProps): JSX.Element => {
  const attachmentThumbnail = (
    <div className="edit-tab-sidebar-attachment-image-container">
      <img
        alt={props.assetName}
        className="edit-tab-sidebar-attachment-image"
        data-private
        onError={(e: SyntheticEvent<HTMLImageElement, Event>): void => handleThumbnailError(
          e,
          props.attachmentExtension,
          props.assetName,
          true, /* isLargeView */
          undefined, /* isHoverImage */
          props.isTask, /* isTask */
        )}
        src={props.src}
      />
    </div>
  );
  return (
    <div className="edit-tab-sidebar-attachment-container">
      {BFG.context.hasFeature('people_tagging') ?
        <ImageOverlay
          buttonText={t`Tag People`}
          href={`/${BFG.brandfolder_slug}/people_tags?${PeoplePageParamKeys.AssetIds}=${props.assetKey}`}
          icon={FontIcons.Tag}
        >
          {attachmentThumbnail}
        </ImageOverlay> : attachmentThumbnail
      }
      <div className="edit-tab-sidebar-attachment-asset-details">
        <span className="asset-name">{props.assetName}</span>
        <div className="file-type-pill">
          <span aria-label="hidden" className="bff-paperclip attachment-count" />
          <span className="count">{props.attachmentCount}</span>
        </div>
      </div>
    </div>
  );
};

export default AttachmentThumbnail;
